import { Option, none } from "widgets-for-react"
import { fromNullable, valueOrExcept } from "../../Shared/utils/option"
import { JumboProps } from "../custom_components/components/jumbo"
import { NewsletterFormBlockProps } from "../custom_components/components/newsletter_block"
import bkw from "./bkw"
import flevo from "./flevo"
import rdam from "./rdam"
import twente from "./twente"
import whiteLabel from "./whitelabel"
import { NavigationItem } from "../../Shared/api/drupal/drupalTypes"

export interface Library {
  logo: () => JSX.Element
  primaryColor: string
  menuLink: (x: NavigationItem, handle: () => void) => JSX.Element
  homeJumbo: (props: JumboProps) => JSX.Element
  footerTop: () => JSX.Element
  newsletterBlock: (props: NewsletterFormBlockProps) => JSX.Element
  collectionSearchUrl: (term: string) => string
  loginUrl: string
  features: {
    autoHyphenate: boolean
    manualHyphenate: boolean
  }
  notFoundPath: string
  searchPlaceholderImage: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
  copy: {
    forms: {
      loadingFailed: string
    }
    vacancies: {
      noVacanciesFound: string
    }
  }
}

// Define LibraryIDs and guard clause
const libraryIDs = ['vbp', 'bkw', 'flevo', 'rdam', 'twente'] as const
export type LibraryID = typeof libraryIDs[number]
const isLibraryID = (id: string): id is LibraryID => libraryIDs.includes(id as LibraryID)

// Define implementations of Library for each LibraryID
type LibraryCustomizations = { [library in LibraryID]: Library}
const libraryCustomizations: LibraryCustomizations = { bkw, flevo, rdam, twente, 'vbp': whiteLabel }

// Set application wide Library at runtime
let _library: Option<Library> = none()
export const setLibrary = (id: string) => {
  if (!isLibraryID(id)) throw new TypeError(`Library ID must be one of: ${libraryIDs.join(', ')}`)
  _library = fromNullable(libraryCustomizations[id])
}

// Get Library at runtime
export const library = (): Library => valueOrExcept(_library, "Library has not yet been set. Make sure to call library() within the context of the React Application component.")
